import { render, staticRenderFns } from "./voteEmotion.vue?vue&type=template&id=284e48a0"
import script from "./voteEmotion.vue?vue&type=script&lang=js"
export * from "./voteEmotion.vue?vue&type=script&lang=js"
import style0 from "./voteEmotion.vue?vue&type=style&index=0&id=284e48a0&prod&lang=scss"
import style1 from "./voteEmotion.vue?vue&type=style&index=1&id=284e48a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports